export const isRelativeUri = (uri: string) => {
  const { origin } = window.location;
  return uri?.startsWith(origin) || !/^(f|ht)tps?:\/\//i.test(uri);
};

export default isRelativeUri;
